// extracted by mini-css-extract-plugin
var _1 = "column--Cf2fSi8M";
var _2 = "customer_info_container--o6HwY2XG";
export { _1 as "column", _2 as "customer_info_container" }
